//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 19/03/2025
// Version       : 1
// Description   : Patentes con la cantidad de combustible que cargaron
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState, useEffect, useMemo } from "react";
import { UrlApi } from "../../services/apirest";
import Navbar from "../Navbar";
import { MaterialReactTable } from "material-react-table";
import { logEventos } from "../../services/services";
// TABLA EN ESPAÑOL
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Box,
  Dialog,
  Typography,
  Button,
  TextField,
  InputAdornment,
  ThemeProvider,
  createTheme,
  useTheme,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { keyframes } from "@emotion/react";

// Componentes
import CargarDatos from "./CargarDatos";
import CargarDatos2 from "./CargarDatos2";
import DetallesPatente from "./DetallesPatente";

// DatePicker
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { esES } from "@mui/x-date-pickers/locales";
import "dayjs/locale/es";

// ICONOS
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ArticleIcon from "@mui/icons-material/Article";
import SearchIcon from "@mui/icons-material/Search";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Animaciones
const slideInShort = keyframes`
  from { transform: translateX(-50px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

const slideOutShort = keyframes`
  from { transform: translateX(0); opacity: 1; }
  to { transform: translateX(-50px); opacity: 0; }
`;

function ReporteGeneral() {
  const [animation, setAnimation] = useState("slideIn");

  const [proveedorSeleccionado, setProveedorSeleccionado] = useState("");

  const globalTheme = useTheme();

  //*************************************************************************************************************************************/

  const [fechaDesde, setFechaDesde] = useState(null);
  const [fechaHasta, setFechaHasta] = useState(null);
  const [data, setData] = useState([]); // Datos de la tabla

  // Buscador para la tabla
  const [filterText, setFilterText] = useState("");

  const filteredData = useMemo(() => {
    if (!filterText) return data;
    const lower = filterText.toLowerCase();
    return data.filter((row) => {
      return (
        row.patente?.toLowerCase().includes(lower) ||
        row.modelo?.toLowerCase().includes(lower) ||
        row.marca?.toLowerCase().includes(lower) ||
        row.sucursal?.toLowerCase().includes(lower)
      );
    });
  }, [data, filterText]);

  //*************************************************************************************************************************************/

  const obtenerDatosFiltrados = () => {
    let url = `${UrlApi}/vehiculos_reporte_combustibles`;

    const formatoFecha = (fecha) => {
      if (!fecha) return null;
      return dayjs(fecha).format("YYYY-MM-DD"); // Transforma fechas en AÑO-MES-DIA
    };

    const desde = formatoFecha(fechaDesde);
    const hasta = formatoFecha(fechaHasta);

    if (desde && hasta) {
      url += `?desde=${desde}&hasta=${hasta}`; // Agrega los parametros DESDE y HASTA en la URL
    }

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        // Al filtrar, se actualizan los valores iniciales
        setInitialFechaDesde(fechaDesde);
        setInitialFechaHasta(fechaHasta);
      })
      .catch((error) => console.error("Error al obtener datos:", error));
  };

  useEffect(() => {
    obtenerDatosFiltrados(); // Datos al iniciar
  }, []);

  const handleDatosGuardados = () => {
    obtenerDatosFiltrados(); // Vuelve a obtener los datos actualizados
  };

  //*************************************************************************************************************************************/

  // ACTIVAR/DESACTIVAR BOTÓN DE FILTRAR
  const [isFilterEnabled, setIsFilterEnabled] = useState(false);
  const [initialFechaDesde, setInitialFechaDesde] = useState(null);
  const [initialFechaHasta, setInitialFechaHasta] = useState(null);

  useEffect(() => {
    const fechasSonValidas = fechaDesde && fechaHasta;
    const fechasCambiaron =
      fechaDesde !== initialFechaDesde || fechaHasta !== initialFechaHasta;
    setIsFilterEnabled(fechasSonValidas && fechasCambiaron);
  }, [fechaDesde, fechaHasta, initialFechaDesde, initialFechaHasta]);

  useEffect(() => {
    const ambasVacias = !fechaDesde && !fechaHasta;
    const ambasTienenValor = fechaDesde && fechaHasta;
    const fechasSonValidas = ambasVacias || ambasTienenValor;
    const fechasCambiaron =
      fechaDesde !== initialFechaDesde || fechaHasta !== initialFechaHasta;

    setIsFilterEnabled(fechasSonValidas && fechasCambiaron);
  }, [fechaDesde, fechaHasta, initialFechaDesde, initialFechaHasta]);

  //*************************************************************************************************************************************/

  // DIALOG PARA AGREGAR DATOS
  const [dialogoCargarDatos, setDialogoCargarDatos] = useState(false);

  // Abrir diálogo
  const handleOpenCargarDatos = () => {
    setDialogoCargarDatos(true);
  };

  // Cerrar diálogo
  const handleCloseCargarDatos = () => {
    setDialogoCargarDatos(false);
  };

  //*************************************************************************************************************************************/

  // DIALOG VER DETALLES DE LA PATENTE
  const [dialogoDetallesPatente, setDialogoDetallesPatente] = useState(false);
  const [patenteSeleccionada, setPatenteSeleccionada] = useState(null);

  // Abrir diálogo
  const handleOpenDetallesPatente = ({ patente, marca, modelo, sucursal }) => {
    setPatenteSeleccionada({ patente, marca, modelo, sucursal });
    setDialogoDetallesPatente(true);
  };

  // Cerrar diálogo
  const handleCloseDetallesPatente = () => {
    setDialogoDetallesPatente(false);
  };

  //*************************************************************************************************************************************/

  // ----------- TABLA ---------------
  const columns = [
    {
      id: "inicial",
      header: "Inicial",
      accessorFn: (row) => row.patente?.charAt(0).toUpperCase() ?? "",
      enableGrouping: true,
      enableSorting: true,
      // Solo renderizar la letra de ese grupo:
      Cell: ({ cell, row }) => (row.getIsGrouped() ? cell.getValue() : null),
      size: 20,
      minSize: 20,
      maxSize: 40,
    },
    {
      accessorKey: "patente",
      header: "Patente",
      filterVariant: "text",
      size: 80,
      Cell: ({ cell }) => cell.getValue() || "-",
    },
    {
      accessorKey: "modelo",
      header: "Modelo",
      filterVariant: "text",
      Cell: ({ cell }) => cell.getValue() || "-",
    },
    {
      accessorKey: "marca",
      header: "Marca",
      filterVariant: "text",
      Cell: ({ cell }) => cell.getValue() || "-",
    },
    {
      accessorKey: "sucursal",
      header: "Sucursal",
      filterVariant: "text",
      Cell: ({ cell }) => cell.getValue() || "-",
    },
    {
      accessorKey: "total_cantidad",
      header: "Cantidad Total",
      size: 100,
      Cell: ({ cell }) => {
        const v = cell.getValue() ?? 0;
        // Si es entero, se muestra sin decimales; si no, con 2 decimales
        return Number.isInteger(v)
          ? v.toLocaleString("es-AR")
          : v.toLocaleString("es-AR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
      },
      muiTableBodyCellProps: {
        align: "right",
      },
    },
  ];

  const customLocalization = {
    ...MRT_Localization_ES,
    body: {
      ...MRT_Localization_ES.body,
      noData: "No hay registros para mostrar",
    },
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
    sorting: [
      { id: "inicial", desc: false }, // Ordeno los grupos A→Z
      { id: "patente", desc: false }, // Para cada grupo se ordenan las patentes A→Z
    ],
    grouping: ["inicial"],
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
      "& .MuiSvgIcon-root": {
        color: "white", // color de los íconos
      },
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { backgroundColor: "#ffffff" },
    variant: "outlined",
    size: "small",
  };

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  //*************************************************************************************************************************************/

  // Para pasar del paso 1 al 2 en la carga de datos
  const [currentStep, setCurrentStep] = useState(1);
  const [normalizedData, setNormalizedData] = useState([]);
  const [configuracion, setConfiguracion] = useState(null);

  const handleNextStep = (normalizedData, configuracion, proveedorId) => {
    setNormalizedData(normalizedData);
    setConfiguracion(configuracion);
    setProveedorSeleccionado(proveedorId); // Guardo el proveedor
    setCurrentStep(2); // Cambio al segundo paso
  };

  const handlePreviousStep = () => {
    setAnimation("slideOut");
  };

  const onAnimationEnd = () => {
    if (animation === "slideOut") {
      setCurrentStep(1);
      setAnimation("slideIn");
    }
  };

  useEffect(() => {
    logEventos(
      "acceso al menu Combustibles",
      "reportes",
      "Lista Combustible de Vehículos",
      localStorage.getItem("user")
    );
  }, []);

  return (
    <>
      <Navbar />
      <Box
        sx={{
          marginTop: "20px",
          marginBottom: "25px",
          marginLeft: "40px",
          marginRight: "40px",
        }}
      >
        <ThemeProvider theme={tableTheme}>
          <MaterialReactTable
            columns={columns}
            data={filteredData}
            initialState={initialState}
            enableGrouping
            positionActionsColumn="last"
            autoResetPageIndex={false}
            enableDensityToggle={false}
            enableFullScreenToggle={false}
            enableColumnActions={true}
            enableColumnFilters={false}
            enableHiding={false}
            localization={customLocalization}
            enableRowSelection={false}
            enableRowActions={true}
            enableColumnOrdering={false}
            enableColumnResizing={false}
            enableGlobalFilter={false}
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            muiTableBodyCellProps={({}) => ({
              align: "left",
              sx: {
                color: "black",
                borderColor: "black",
              },
            })}
            muiTableBodyRowProps={({ table, row }) => {
              const rowIndex = table
                .getRowModel() //  Obtengo todas las filas visibles en el orden actual
                .rows.findIndex((r) => r.id === row.id); // Busca el índice real de la fila en la tabla
              return {
                sx: {
                  backgroundColor: rowIndex % 2 === 0 ? "#ffffff" : "#f0f0f0", // Alternar los colores, incluso si hay agrupaciones o filtrados
                },
              };
            }}
            renderTopToolbarCustomActions={() => (
              <>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "nowrap", // Evita que pase a la siguiente línea
                    width: "100%",
                  }}
                >
                  <Typography variant="poster" fontSize={26}>
                    Combustible de Vehículos
                  </Typography>

                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="es"
                    localeText={
                      esES.components.MuiLocalizationProvider.defaultProps
                        .localeText
                    }
                  >
                    <DatePicker
                      label="Desde"
                      value={fechaDesde}
                      onChange={(newValue) => setFechaDesde(newValue)}
                      maxDate={fechaHasta || dayjs()}
                      slotProps={{
                        actionBar: { actions: ["clear"] }, // Limpiar Fecha
                        textField: {
                          size: "small",
                          sx: { width: 150 },
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="es"
                    localeText={
                      esES.components.MuiLocalizationProvider.defaultProps
                        .localeText
                    }
                  >
                    <DatePicker
                      label="Hasta"
                      value={fechaHasta}
                      onChange={(newValue) => setFechaHasta(newValue)}
                      minDate={fechaDesde}
                      maxDate={dayjs()}
                      slotProps={{
                        actionBar: { actions: ["clear"] }, // Limpiar Fecha
                        textField: {
                          size: "small",
                          sx: { width: 150 },
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    startIcon={<FilterAltIcon />}
                    sx={{ mt: 0 }}
                    onClick={obtenerDatosFiltrados}
                    disabled={!isFilterEnabled}
                  >
                    Filtrar
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ mt: 0, ml: 3 }}
                    onClick={handleOpenCargarDatos}
                    startIcon={<AddBoxOutlinedIcon />}
                  >
                    Agregar Datos
                  </Button>

                  <Box
                    sx={{
                      ml: "auto",
                      minWidth: "150px",
                      maxWidth: "300px",
                      width: {
                        xs: "100%",
                        sm: "300px",
                      },
                    }}
                  >
                    <TextField
                      fullWidth
                      value={filterText}
                      onChange={(e) => setFilterText(e.target.value)}
                      placeholder="Buscar..."
                      size="small"
                      variant="outlined"
                      autoComplete="off"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: 1,
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#ccc",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#888",
                        },
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                          {
                            borderColor: "#2471A3",
                          },
                      }}
                    />
                  </Box>
                </Box>
              </>
            )}
            renderRowActions={({ row }) => (
              <>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() =>
                    handleOpenDetallesPatente({
                      patente: row.original.patente,
                      marca: row.original.marca,
                      modelo: row.original.modelo,
                      sucursal: row.original.sucursal,
                    })
                  }
                  startIcon={<ArticleIcon />}
                >
                  Ver Detalles
                </Button>
              </>
            )}
          />
        </ThemeProvider>
      </Box>

      {/* DIALOG CARGAR DATOS */}
      <Dialog
        fullWidth
        maxWidth={"xl"}
        open={dialogoCargarDatos}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            // Al presionar ESCAPE o Click a la zona sin dialog no hace nada, evita el cierre del diálogo
          } else {
            handleCloseCargarDatos(event, reason);
          }
        }}
      >
        <Box
          style={{
            borderWidth: 5,
            borderStyle: "solid",
            borderColor: "#2B76A6",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: 2,
              position: "relative",
            }}
          >
            <Typography
              variant="h6"
              color="white"
              sx={{
                display: "inline-block",
                backgroundColor: "#2B76A6",
                borderBottomRightRadius: "12px",
                padding: "8px 18px",
                zIndex: 1,
              }}
            >
              Cargar Datos
            </Typography>

            {currentStep === 2 && (
              <Box
                sx={{
                  display: "inline-block",
                  backgroundColor: "#F5F5F5",
                  padding: "6px 12px",
                  borderBottomRightRadius: "12px",
                  animation: `${
                    animation === "slideIn" ? slideInShort : slideOutShort
                  } 400ms ease forwards`,
                }}
                onAnimationEnd={onAnimationEnd}
              >
                <Typography variant="subtitle1" color="#757575">
                  Vista Previa
                </Typography>
              </Box>
            )}
          </Box>

          {currentStep === 1 ? (
            <CargarDatos
              handleCloseCargarDatos={handleCloseCargarDatos}
              handleNextStep={handleNextStep}
              proveedorSeleccionado={proveedorSeleccionado}
              setProveedorSeleccionado={setProveedorSeleccionado}
            />
          ) : (
            <CargarDatos2
              data={normalizedData}
              config={configuracion}
              proveedorSeleccionado={proveedorSeleccionado}
              handlePreviousStep={handlePreviousStep}
              onDatosGuardados={handleDatosGuardados}
            />
          )}
        </Box>
      </Dialog>

      {/* DIALOG VER DETALLES */}
      <Dialog
        fullScreen
        TransitionComponent={Transition}
        open={dialogoDetallesPatente}
        onClose={handleCloseDetallesPatente}
      >
        {patenteSeleccionada && ( // SOLO RENDERIZAR CUANDO HAYA PATENTE SELECCIONADA
          <DetallesPatente
            handleCloseDetallesPatente={handleCloseDetallesPatente}
            patenteSeleccionada={patenteSeleccionada}
            fechaDesdeReporte={fechaDesde}
            fechaHastaReporte={fechaHasta}
          />
        )}
      </Dialog>
    </>
  );
}

export default ReporteGeneral;
